const ContentWrapper = ({ dataLabel, children }) => {
  return (
    <div className="table__body-item-content" data-label={dataLabel}>
      {children}
    </div>
  );
};

export default ContentWrapper;
